module.exports = [{"name":"HERO","layout":"CONTENT_CENTER","embed":"domain-availability-checker","assetName":"bravenet_domains_supported_tlds"},{"name":"EASY","layout":"CONTENT_LEFT","assetName":"bravenet_domains_easy_visual_domain_management"},{"name":"PRIVACY_PROTECTION","layout":"CONTENT_RIGHT","assetName":"bravenet_domains_privacy_protection"},{"name":"SUPPORT","layout":"CONTENT_LEFT","class":"flush-bottom","assetName":"bravenet_domains_fantastic_support"}]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/domains/panels.json
// module id = pCQx
// module chunks = 0